export class Scan{
    scanName: string = "";
    scanType: string = "";
    plateType: string = "";
    sticky: boolean = false;
    regex: string = "";
    barcodeTemplate = "";

    static newScanObject(scanName: string, scanType: string, plateType: string, sticky: boolean=false, regex: string="", barcodeTemplate: string=""){
        let s = new Scan();
        s.scanName = scanName;
        s.scanType = scanType;
        s.plateType = plateType;
        s.sticky = sticky;
        s.regex = regex;
        s.barcodeTemplate = barcodeTemplate;
        return s;
    }
}